import {
  OrderShipmentRefundSummary,
  ShippingMethodCode,
} from '@web/shared/module/shop';
import { Guid, Nillable } from '@web/utils';

export class AdminOrderRefundDataShipment {
  public constructor(
    private readonly data: {
      id: Guid;
      price: number;
      methodName: string;
      methodCode: ShippingMethodCode;
      refundSummary?: Nillable<OrderShipmentRefundSummary>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get price(): number {
    return this.data.price;
  }

  public get methodName(): string {
    return this.data.methodName;
  }

  public get methodCode(): ShippingMethodCode {
    return this.data.methodCode;
  }

  public get refundSummary(): Nillable<OrderShipmentRefundSummary> {
    return this.data.refundSummary;
  }
}
